import { authReducer } from '../../authentication/reducers/AuthReducer';
import authenticationSaga from '../../authentication/sagas/AuthSaga';
import { authFormReducer } from '../../authForm/reducers/AuthFormReducer';
import authFormSaga from '../../authForm/sagas/AuthFormSaga';
import { basketReducer } from '../../basket/reducers/BasketReducer';
import basketSaga from '../../basket/sagas/BasketSagas';
const loadGiftVoucherDynamicModule = () => ({
    id: 'GiftVoucher',
    reducerMap: {
        authentication: authReducer,
        authForm: authFormReducer,
        basket: basketReducer,
    },
    sagas: [authenticationSaga, authFormSaga, basketSaga],
});
export default loadGiftVoucherDynamicModule;
